import React from 'react'
import { Block, Typography } from '@xprog/prensa'
import replace from 'lodash/replace'

const Horoscope = (props) => {
  const blockProps = {
    fontFamily: '$primary',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '29px',
    px: '$0',
    py: '$0',
    width: '100%',
    '.item-horoscope': {
      align: ['column', 'left', 'top'],
      '@lg': {
        align: ['row', 'left', 'top'],
      },
      'h3': {
        fontSize: '21px',
        fontWeight: 700,
        lineHeight: '25px',
        mb: '$2',
        '> span': {
          fontSize: '16px',
          fontWeight: 400
        }
      },
      '> img': {
        width: '190px'
      },
      '> div': {
        width: '100%',
        '@lg': {
          ml: '30px',
          width: 'calc(100% - 220px)'
        }
      },
      'a': {
        color: '#164194 !important',
        fontWeight: 'bold'
      }
    }
  }
  const link1 = 'https://www.personare.com.br/horoscopo?utm_source=Parceiro&utm_medium=Grupo%20Jaime%20C%C3%A2mara&utm_campaign=Horoscopo%20Botao%201&ref=grupo-jaime-camara'
  const link2 = 'https://www.personare.com.br/signos?utm_source=Parceiro&utm_medium=Grupo%20Jaime%20C%C3%A2mara&utm_campaign=Horoscopo%20Botao%202&ref=grupo-jaime-camara'
  const link1Html = `<p>Leia seu <a href='${link1}' title='Leia seu Horóscopo Personalizado'>Horóscopo Personalizado</a>.</p>`
  const link2Html = `<p>Saiba tudo sobre seu <a href='${link2}' title='Saiba tudo sobre seu signo'>signo</a>.</p>`
  const textParsed = replace(props.content, new RegExp('<div class="link_markup"></div>', 'g'), `${link1Html}${link2Html}`)
  return (
    <Block css={blockProps}>
      <div dangerouslySetInnerHTML={{ __html: textParsed }} />
    </Block>
  )
}

export default Horoscope
